import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import reducer from '@app/reducer';
import throttle from 'lodash.throttle';
import { loadState, saveState } from '@chama/utils/functions/local-storage';
import handleVersion from '@chama/utils/functions/version-handler';
import { setServerTimeOffset, SET_CURRENT_TIME } from '@app/actions/time';
import { updateToken } from '@app/modules/auth/redux';
import {
  firebaseConnected,
  firebaseDisconnected,
  firebaseAuthenticated,
  firebaseUnAuthenticated,
} from '@app/actions/firebase';
import { apiRetryScheduled, apiRetrySucceeded } from '@app/actions/api-connectivity';

const configureStore = ({ firebaseClient, api, applicationFacade }) => {
  const inititalState = loadState();
  const logger = createLogger({
    predicate: (getState, action) => {
      // only log when debugging is enabled
      if (!getState().featureToggles.debuggingEnabled) {
        return false;
      }
      if (action.type === SET_CURRENT_TIME) {
        // don't spam the console with exhaustive 'SET_CURRENT_TIME' actions
        console.log('action SET_CURRENT_TIME');
        return false;
      }

      return true;
    },
  });

  const thunkWithApi = thunk.withExtraArgument({
    api,
    firebaseClient,
    applicationFacade,
  });
  const middlewares = applyMiddleware(thunkWithApi, logger);
  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const enhancers =
    process.env.NODE_ENV !== 'production' ? composeEnhancers(middlewares) : middlewares;
  const store = createStore(reducer, inititalState, enhancers);

  api.onRetryScheduled(t => {
    store.dispatch(apiRetryScheduled(t));
  });

  api.onRetrySucceeded(() => {
    store.dispatch(apiRetrySucceeded());
  });

  firebaseClient.onConnectionStateChange(connected => {
    if (connected) {
      store.dispatch(firebaseConnected());
    } else {
      store.dispatch(firebaseDisconnected());
    }
  });

  firebaseClient.onTokenChanged(user => {
    if (user) {
      store.dispatch(updateToken(user));
      store.dispatch(firebaseAuthenticated(user.uid));
    } else {
      store.dispatch(firebaseUnAuthenticated());
    }
  });

  firebaseClient.onServerTimeOffsetChanged(offset => {
    store.dispatch(setServerTimeOffset(offset));
  });

  firebaseClient.onVersionChanged(handleVersion);

  store.subscribe(
    throttle(() => {
      const state = store.getState();
      const { featureToggles, reminders } = state;

      saveState({
        featureToggles,
        reminders,
      });
    }, 1000),
  );

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js